import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { EngineService } from '../services/engine-service';
import { catchError, of } from 'rxjs';

export const engineResolver: ResolveFn<any> = (route, state) => {
  const engineService = inject(EngineService);
  const id = route.paramMap.get('id') || route.paramMap.get('serialNumber') || '';
  if (!id) {
    return of(null);
  }
  return engineService.getEngineById(id).pipe(
    catchError(() => of(null))
  );
};
